module.exports = " <a ng-href=\"{{ $ctrl.hasImageExtension() ? '' : $ctrl.link }}\" ng-click=\"$ctrl.showImageOverlayOrDownload()\" download>\n    <i ng-if=\"$ctrl.showIcon\" class=\"fa fa-paperclip\"></i>\n    {{$ctrl.fileName}}\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-feed-attachment/supportFeedAttachment.component.html
// module id = 739
// module chunks = 0